import { render, staticRenderFns } from "./carousalbg.vue?vue&type=template&id=1b37c038&scoped=true"
import script from "./carousalbg.vue?vue&type=script&lang=js"
export * from "./carousalbg.vue?vue&type=script&lang=js"
import style0 from "./carousalbg.vue?vue&type=style&index=0&id=1b37c038&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b37c038",
  null
  
)

export default component.exports